import "./bootstrap";
import $ from "jquery";
import Alpine from "alpinejs";
import "lazysizes";
import { Fancybox } from "@fancyapps/ui/dist/fancybox/fancybox.esm.js";
import Swal from "sweetalert2";
import AOS from "aos";
import "flowbite";
import Swiper from "swiper/bundle";
import "select2";
import { CountUp } from "countup.js";
import { DateRangePicker } from "daterangepicker/daterangepicker.js";
import moment from "moment";
import "timepicker";
window.$ = window.jQuery = $;
window.AOS = AOS;
window.Fancybox = Fancybox;
window.Swal = Swal;
window.Alpine = Alpine;
window.Swiper = Swiper;
window.CountUp = CountUp;
window.daterangepicker = DateRangePicker;
window.moment = moment;
// Initialise jQuery
$(function () {
    // Any jQuery scripts...
    AOS.init({
        // once: true,
    });
    Fancybox.bind("[data-fancybox]", {
        hideScrollbar: false,
        closeExisting: true,
        tpl: {
            closeButton:
                '<button data-fancybox-close class="f-button is-close-btn" style="top:0 !important; background-color: #fff; color: #686868" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"/></svg></button>',
        },
    });
    Alpine.start();

    // Find all Statistics on page, put them inside a variable
    var counter = $(".counterUp");

    // For each Statistic we find, animate it
    counter.each(function (index) {
        // Find the value we want to animate (what lives inside the p tags)
        var value = $(counter[index]).html();
        // Start animating
        var statisticAnimation = new CountUp(counter[index], value, {
            enableScrollSpy: true,
        });
        statisticAnimation.start();
    });
});
const loading = {
    start: function () {
        $("#loading").css("display", "flex");
    },
    stop: function () {
        $("#loading").css("display", "none");
    },
};
$.loading = loading;
